import { useState } from "react";
import { Phone } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { BRAND } from "@/data/content";

const FaWhatsapp = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.887 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

export default function FloatingButtons() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-6 right-5 z-[90] flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.9 }}
            className="flex flex-col gap-2"
          >
            {BRAND.phoneRaw.map((p, i) => (
              <a key={p} href={`tel:${p}`} data-testid={`float-call-${i}`} className="flex items-center gap-2 bg-[#111] border border-[#e7c15a]/40 text-[#e7c15a] px-4 py-2 text-xs whitespace-nowrap shadow-xl">
                <Phone size={14} strokeWidth={1.5} /> {BRAND.phones[i]}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <a
        href={`https://wa.me/${BRAND.whatsapp}?text=Hi%20Vernika%20Designs,%20I'd%20like%20to%20enquire%20about%20your%20interior%20products.`}
        target="_blank"
        rel="noreferrer"
        data-testid="float-whatsapp"
        className="h-14 w-14 grid place-items-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="float-call-toggle"
        className="h-14 w-14 grid place-items-center rounded-full bg-[#e7c15a] text-[#050505] shadow-[0_8px_30px_rgba(212,175,55,0.4)] hover:scale-110 transition-transform"
        aria-label="Call"
      >
        <Phone size={24} strokeWidth={2} />
      </button>
    </div>
  );
}
